import type { GetUserResponse, User } from "@auth/types/auth";

export const getUserResponseToUserMap = (from: GetUserResponse): User => {
    return {
        class: from.user.Clase,
        defaultReplacement: from.user.DefaultReposicion,
        email: from.user.Email,
        employeeNumber: from.user.NoEmpleado,
        firstName: from.user.Nombre,
        groupId: from.user.idGrupo,
        groupName: from.user.NombreGrupo,
        id: from.user.idGrupo,
        lastName: from.user.Apellidos,
        level: from.user.Level,
        profileImage: from.user.ImgPerfil,
        sapPassword: from.user.PasswordSAP,
        sapUser: from.user.UserSAP,
        userCode: from.user.UserCode,
    };
};